import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, FormField, Popover, SpaceBetween, SplitPanel, StatusIndicator, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { format, parse } from 'date-fns';
import Favorites from '../../../../../../components/extras/Favorites';
import Spacer from '../../../../../../components/extras/Spacer';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setLoading } from '../../../../../commons/functions';



export const MembersAccountsPACPage = () => {
    //const storeAdmin = useStoreAdmin();

    const { menu, idUser } = useGlobalState();
    const [subscriptions, setSubscriptions] = useState<any[]>([]);
    const [charges, setCharges] = useState<any[]>([]);
    const [subscription, setSubscription] = useState<any>();
    const [PAC, setPAC] = useState<any>();


    const handleRefresh = async () => {
        ///private/user/movements/pac/initsubscription
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/pac/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ orderBy: "dateCreated", order: "desc" }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                setSubscriptions(dataWeb.subscriptions)
                if (dataWeb?.pac?.payment_method?.pac) {
                    setPAC(dataWeb.pac.payment_method)
                }
                setSubscriptions(dataWeb.subscriptions)
                if (dataWeb?.charges) {
                    setCharges(dataWeb.charges)
                }
                //console.log(dataWeb.subscriptions)
                //
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }
    const handleRemoveIntent = async (id: string) => {
        ///private/user/movements/pac/initsubscription
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/pac/delete',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idUser: idUser, id: id }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                handleRefresh();
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }
    const ammount = Math.floor(Math.random() * (500)) + 2000;

    const handleCharge = async () => {
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/pac/charge',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idUser: idUser, ammount: ammount }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                handleRefresh();
                //
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }

    const handleInitSubscription = async () => {
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/pac/initsubscription',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({}),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                if (dataWeb.subscription.code === 0) {
                    window.location = dataWeb.subscription.url;

                }
                /*
                const initializeFintoc = async () => {
                    try {
                        const options = {
                            holderType: 'individual',
                            widgetToken: dataWeb.subscription.widget_token,
                            product: 'subscriptions',
                            publicKey: 'pk_test_UgGijQApUmMqo5sD_j6owqro9FDmqX5k',
                            onSuccess: () => {
                                console.log("success")
                                handleRefresh();
                            },
                            onExit: function onExit(errorReason: any) {
                                console.log("error", errorReason);
                                addNotification("Proceso de suscripción cancelado", "error", setData);
                                handleRemoveIntent(dataWeb.subscription.id);
                            },
                            onEvent: function onEvent(eventName: any, metadata: any) {
                                console.log("event", eventName, metadata);
                            }
                        }
                        const instance = await getFintoc();
                        const widget = instance.create(options);
                        widget.open();
                        //console.log(instance)

                        //setFintoc(instance);
                    } catch (error) {
                        console.error("Failed to load Fintoc:", error);
                    } finally {
                        //setLoading(false);
                    }
                };
                initializeFintoc();
                */
                //
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }
    useEffect(() => {
        handleRefresh();
    }, []);
    const error = (item: any) => {
        if (item) {
            if (item === "login_invalid_credentials")
                return "Credenciales inválidas";
            else if (item === "login_credentials_locked")
                return "Credenciales bloquedas";
            else if (item === "authorization_failed")
                return "Autorización fallida";
            else if (item === "authorization_timeout")
                return "Autorización expirada";
            else if (item === "request_timeout")
                return "Tiempo de espera agotado";
            else if (item === "subscription_intent_expired")
                return "Intento de suscripción expirado";
            else if (item === "internal_error")
                return "Error interno";
            else if (item === "insufficient_funds")
                return "Fondos insuficientes";
            else if (item === "subscription_inactive")
                return "Convenio inactivo";
            else if (item === "charge_amount_limit_exceeded")
                return "Límite de monto excedido";
            else if (item === "other")
                return "Error desconocido";

        } else {
            return ""
        }

    }

    const status = (item: any) => {
        if (item.type === "subscription_intent") {
            if (item.status === "created") {
                return <FormField label={"Ingresada"}></FormField>;
            } else if (item.status === "progress") {
                return <FormField label={"Esperando autorización"}></FormField>;
            } else if (item.status === "succeeded") {
                return <FormField label={"Finalizado"}></FormField>;
            } else if (item.status === "rejected") {
                return <FormField label={"Rechazado"}></FormField>;
            } else if (item.status === "failed") {
                return <FormField label={"Error"}>{error(item.json.public_error)}</FormField>;
            } else {
                return item.status;
            }
        }
        else if (item.type === "subscription") {
            if (item.status === "pending") {
                return <FormField label={"Pendiente"}></FormField>;
            }
            else if (item.status === "active") {
                return <FormField label={"Activo"}></FormField>;
            }
            else if (item.status === "canceled") {
                return <FormField label={"Cancelado"}></FormField>;
            }
        }
        else if (item.type === "charge") {
            if (item.status === "pending") {
                return <FormField label={"Pendiente"}></FormField>;
            }
            else if (item.status === "succeeded") {
                return <FormField label={"Completado"}></FormField>;
            }
            else if (item.status === "in_progress") {
                return <FormField label={"Gestionando"}></FormField>;
            }
            else if (item.status === "failed") {
                return <FormField label={"Rechazada"}>{error(item.json.failure_code)}</FormField>;
            }
        }
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanelOpen={!!subscription}
            onSplitPanelToggle={(open) => {
                !open.detail.open ? window.location.hash = "#members/accounts/pac" : null
            }
            }
            splitPanel={
                <SplitPanel hidePreferencesButton closeBehavior="hide">
                    <Button onClick={() => handleCharge()}>Cargar</Button>
                </SplitPanel>
            }
            content={
                <SpaceBetween size="s">
                    <Header actions={
                        <SpaceBetween direction='horizontal' size='xs'>


                            <Favorites />
                        </SpaceBetween>
                    } variant="h1"
                        description={"Suscripciones al sistema de pago automático con cargo a cuenta corriente"}
                    >Inscripciones PAC</Header>
                    <SpaceBetween size='l' direction='vertical'>
                        {!!PAC?.pac.status && (
                            <Alert type={PAC?.pac.status === "pending" ? "info" : PAC?.pac.status === "active" ? "success" : "warning"} header="Información del PAC">
                                {PAC?.pac.status === "pending" ? <>
                                    Su convenio PAC <strong>{PAC.pac.institution.name}</strong> con {PAC.pac.account_type === "checking_account" ? "cuenta corriente" : "cuenta vista"} número <strong>{PAC.pac.account_number} </strong> asociado al RUT <strong>{PAC.pac.account_holder_id}</strong> se encuentra pendiente de autorización por parte de su institución bancaria.<br /><br /> Su identificador de convenio es el <strong>{`${PAC.id.toString().substr(0, PAC.id.toString().length - 10)}**********`}</strong></>
                                    : PAC?.pac.status === "active" ? <>
                                        Se encuentra activo su PAC del <strong>{PAC.pac.institution.name}</strong> con {PAC.pac.account_type === "checking_account" ? "cuenta corriente" : "cuenta vista"} número <strong>{PAC.pac.account_number}</strong> asociado al RUT <strong>{PAC.pac.account_holder_id}</strong>. <br /><br />Su identificador de convenio es el <strong>{`${PAC.id.toString().substr(0, PAC.id.toString().length - 10)}**********`}</strong>
                                    </>
                                        : PAC?.pac.status === "canceled" ? <>
                                            Su convenio PAC del <strong>{PAC.pac.institution.name}</strong> con {PAC.pac.account_type === "checking_account" ? "cuenta corriente" : "cuenta vista"} número <strong>{PAC.pac.account_number}</strong> asociado al RUT <strong>{PAC.pac.account_holder_id}</strong> se encuentra cancelado por parte de su institución bancaria. <br /><br />Su identificador de convenio es el <strong>{`${PAC.id.toString().substr(0, PAC.id.toString().length - 10)}**********`}</strong>
                                        </>
                                            : null}

                            </Alert>
                        )}

                        {!PAC && (
                            <Box textAlign='center' variant="h5">
                                <SpaceBetween direction='vertical' size="xs">
                                    <Spacer height={50} />
                                    <b>No tiene convenio PAC activo.</b>
                                    <Button variant="primary" onClick={() => {
                                        handleInitSubscription()
                                    }}>Suscribir</Button>
                                </SpaceBetween>
                            </Box>
                        )}
                        {!!PAC && PAC.pac.status === "active" && (
                            <>Si desea <strong>cancelar</strong> este convenio PAC debe realizarlo directamente en su institución bancaria ({PAC.pac.institution.name})</>
                        )}

                        {!!PAC && PAC.pac.status === "canceled" && (

                            <Box textAlign='center' variant="h5">
                                <SpaceBetween direction='vertical' size="xs">
                                    <Spacer height={50} />
                                    Su convenio PAC actual se encuentra cancelado.
                                    <Button variant="primary" onClick={() => {
                                        handleInitSubscription()
                                    }}>Suscribir</Button>
                                </SpaceBetween>
                            </Box>
                        )}
                        {/*(idUser == 7003 || idUser == 6705) && (
                            <Box textAlign='center' variant="h5">
                                <Button onClick={() => handleCharge()}>Cargar ${ammount}</Button>
                            </Box>
                        )*/}

                        {charges.length > 0 && (
                            <Table
                                columnDefinitions={[
                                    { id: 'ID', header: 'ID', cell: item => item?.json?.metadata?.id },
                                    {
                                        id: 'dateCreated', header: 'Ingreso', cell: item => (
                                            <FormField label={format(parse(item?.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                                                {format(parse(item?.dateCreated, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}
                                            </FormField>
                                        )
                                    },
                                    {
                                        id: 'dateUpdated', header: 'Actualización', cell: item => (
                                            <FormField label={format(parse(item?.dateUpdated, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")}>
                                                {format(parse(item?.dateUpdated, "dd-MM-yyyy HH:mm", new Date()), "HH:mm")}
                                            </FormField>
                                        )
                                    },
                                    {
                                        id: 'amount', header: 'Cargo', cell: item => formatCurrency(item?.json?.amount, "CLP")
                                    },
                                    {
                                        id: 'status', header: 'Estado', cell: item => (
                                            item?.json?.status === "created" ?
                                                <StatusIndicator type="loading">
                                                    Pendiente
                                                </StatusIndicator>
                                                : item?.json?.status === "succeeded" ?
                                                    <StatusIndicator type="success">
                                                        <Popover header="Asignación" content={`El pago ha sido asignado al movimiento #${item?.idMovement} en su cuenta club`}>
                                                            Ejecutado
                                                        </Popover>
                                                    </StatusIndicator>
                                                    : item?.json?.status === "failed" ?
                                                        <StatusIndicator type="error">
                                                            Error
                                                        </StatusIndicator>
                                                        : null
                                        )
                                    },
                                ]}
                                items={charges}
                                stickyHeader
                            />
                        )}
                    </SpaceBetween>
                </SpaceBetween >
            }
        />
    );
};
